// ajax錯誤處理
const successMsg = {
    save: "儲存成功",
    trash: "刪除成功",
    remove: "刪除成功",
    recovery: "復原成功",
};

const errorHandlerMixin = {
    methods: {
        /**
         * 顯示 ajax 錯誤訊息
         * 網路層失敗（斷線、逾時、後端沒回應、CORS）時 axios 的 error 沒有 response，
         * 直接取 error.response.data 會在錯誤處理裡再丟一次 TypeError，
         * 蓋掉原本的錯誤又跳不出訊息，畫面上只會看到轉圈消失後毫無反應
         * @param {Error} error axios 錯誤物件
         */
        showAjaxErrorMsg(error) {
            console.log(error);
            const data = error && error.response ? error.response.data : null;

            if (data && data.ErrorCode == "WL0009") {
                this.$store.dispatch("openTokenExpired");
            }

            this.$message.closeAll();
            this.$message({
                type: "error",
                message: (data && data.ErrorMessage) || "連線失敗，請稍後再試",
                duration: 5000
            });
        },
        getErrorHandler(error) {
            this.showAjaxErrorMsg(error);
        },
        postErrorHandler(error) {
            this.showAjaxErrorMsg(error);
        },
        showAjaxSuccessMsg(action = "save") {
            this.$message.closeAll();
            this.$message({
                type: "success",
                message: successMsg[action],
                duration: 5000
            });
        },
    },
};

const AxiosMixin = {
    methods: {
        async mAxiosGet(url, params = {}, loadingShow = false, ...args) {
            // --- 向下相容檢查 ---
            // 舊簽名: mAxiosGet(url, thenCB, params, loadingShow, thenCatch)
            // 如果第二個參數是函式，則判定為舊版的回呼模式
            if (typeof params === 'function') {
                const thenCB = params;
                const oldParams = loadingShow || {}; // 舊的第三個參數
                const oldLoadingShow = args.length > 0 ? args[0] : false; // 舊的第四個參數
                const thenCatch = args.length > 1 ? args[1] : this.getErrorHandler; // 舊的第五個參數
                if (location.hostname === 'localhost')
                {
                    console.warn(`[Deprecation] mAxiosGet is being called with an outdated callback style for URL: ${url}. Please refactor to use async/await or .then().`);
                }

                // 使用新的 Promise 模式，但串接舊的回呼函式來處理
                return this.mAxiosGet(url, oldParams, oldLoadingShow)
                    .then(thenCB)
                    .catch(thenCatch);
            }
            // --- 檢查結束 ---
            if (!localStorage.User) {
                this.$store.dispatch("openTokenExpired");
                throw new Error("User not authenticated."); // 中斷執行
            }
            this.$http.defaults.headers.common["X-Jesda-Api-Key"] = JSON.parse(
                localStorage.User
            ).tokenId;
            const loading = loadingShow ?
                this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                }) :
                null;

            try {
                const response = await this.$http.get(url, {
                    params,
                });
                return response.data;
            } catch (error) {
                this.getErrorHandler(error);
                throw error; // 重新拋出錯誤，以便呼叫方可以捕獲它
            } finally {
                if (loading) {
                    loading.close();
                }
            }
        },
        async mAxiosPost(url, FormData, ...args) {
            // --- 向下相容檢查 ---
            // 舊簽名: mAxiosPost(url, FormData, thenCB)
            // 如果有第三個參數且是函式，則判定為舊版的回呼模式
            if (args.length > 0 && typeof args[0] === 'function') {
                const thenCB = args[0];
                if (location.hostname === 'localhost')
                {
                    console.warn(`[Deprecation] mAxiosPost is being called with an outdated callback style for URL: ${url}. Please refactor to use async/await or .then().`);
                }

                // 使用新的 Promise 模式，但串接舊的回呼函式
                return this.mAxiosPost(url, FormData)
                    .then(thenCB)
                    .catch(() => { /* 錯誤已在 mAxiosPost 內部處理，此處僅為接住 Promise 的 reject 狀態 */ });
            }
            // --- 檢查結束 ---

            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            try {
                const response = await this.$http.post(url, FormData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                return response.data;
            } catch (error) {
                this.postErrorHandler(error);
                throw error; // 重新拋出錯誤，以便呼叫方可以捕獲它
            } finally {
                loading.close();
            }
        },
        mIframePDF(url, params = {}, type = 'get') {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            const removeEl = document.querySelector(".show-container iframe");
            if (removeEl !== null) {
                removeEl.remove();
            }
            
            const thenCB = (response) => {
                let blob = new Blob([response.data], {
                    type: "application/pdf",
                });
                let iframe = document.createElement("iframe");
                iframe.setAttribute("height", "100%");
                iframe.setAttribute("width", "100%");
                iframe.setAttribute("id", "ifm");
                let showDom = document.getElementsByClassName("show")[0];
                iframe.src = window.URL.createObjectURL(blob);
                showDom.appendChild(iframe);
                loading.close();
            }

            const thenCatch = (error) => {
                const reader = new FileReader();
                reader.addEventListener("loadend", (e) => {
                    const result = JSON.parse(e.srcElement.result);
                    loading.close();
                    this.$message.closeAll();
                    this.$message({
                        type: "error",
                        message: result.ErrorMessage,
                        duration: 5000
                    });
                });
                reader.readAsText(error.response.data);
            }

            if (type === 'post') {
                this.$http
                .post(url, params, {
                    responseType: "blob",
                })
                .then(thenCB)
                .catch(thenCatch);
                return;
            }

            this.$http
                .get(url, {
                    responseType: "blob",
                    params,
                })
                .then(thenCB)
                .catch(thenCatch);
        },
        mDownloadFile(url, download = true, fileName = "", params = {}, thenCB = () => { }, type = 'get') {
            // download false 為另開視窗
            // fileName 為固定檔案下載名稱(須包含副檔名)
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            let blobSetting = {
                responseType: "blob",
                params,
            };

            if (type === 'post') {
                blobSetting = {
                    responseType: "blob",
                }
            }

            let sendData = type == 'get' ? blobSetting : params;

            this.$http[type](url, sendData, type == 'get' ? null : blobSetting).then((response) => {
                if (download) {

                    // 直接下載
                    let blob = new Blob([response.data], {
                        type: "application/octet-stream",
                    });
                    let link = document.createElement("a");
                    fileName =
                        fileName ||
                        decodeURI(
                            this.getFileName(response.headers["content-disposition"])
                        );
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                } else {
                    // pdf另開視窗
                    var file = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
                loading.close();
                thenCB();
            })
                .catch((error) => {
                    const reader = new FileReader();
                    reader.addEventListener("loadend", (e) => {
                        const result = JSON.parse(e.srcElement.result);
                        loading.close();
                        this.$message.closeAll();
                        this.$message({
                            type: "error",
                            message: result.ErrorMessage,
                            duration: 5000
                        });
                    });
                    reader.readAsText(error.response.data);
                });
        },
        getFileName(contentDispStr) {
            return contentDispStr
                .substr(contentDispStr.indexOf("=") + 1)
                .replace("+", " ");
        },
    },
};

const HandlerMixin = {
    methods: {
        handleEnum(object = {}) {
            let arr = [];
            Object.keys(object).forEach((item) => {
                arr.push({
                    label: object[item],
                    value: parseInt(item),
                });
            });
            return arr;
        },
    },
};

export {
    errorHandlerMixin,
    AxiosMixin,
    HandlerMixin
};